import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { blackListWithdrawalsStore, } from "../stores/blackListWithdrawals";
import { blackListWithdrawalsEditModalStore } from "../stores/blackListWithdrawalsEditModal";
import { blackListWithdrawalsAddModalStore } from "../stores/blackListWithdrawalsAddModal";
/* ------- */

class BlackListWithdrawals extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadBlackListWithdrawals();
	}


	deleteBlackListWithdrawal(id) {
		const data = {
			id,
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "blackListWithdrawals",
			method: "delete"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Delete " + id  + " was success");
			this.props.Interface.loadBlackListWithdrawals();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setBlackListWithdrawal({ ...this.props.blackListWithdrawal, loaded: true, error });
		})
	}

	render() {
		return (
			<>
				{this.props.blackListWithdrawals.loaded && this.props.blackListWithdrawals.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.blackListWithdrawals.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.blackListWithdrawals.error.code} | request timestamp: {this.props.blackListWithdrawals.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.blackListWithdrawals.loaded}
					sortingColumn={{ sortingField: this.props.blackListWithdrawals.sorting.sortingColumn.column }}
					sortingDescending={this.props.blackListWithdrawals.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setBlackListWithdrawals({ ...this.props.blackListWithdrawals, sorting: {
								...this.props.blackListWithdrawals.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadBlackListWithdrawals();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setBlackListWithdrawalsEditModal({ ...this.props.blackListWithdrawalsEditModal, id: item.id, description: item.description, wallet: item.wallet, show: true });
										}, 0);
									}}
									children={item.id}
								/>
							),
						},
						{ id: "wallet", header: "Wallet", sortingField: "wallet", cell: (item) => item.wallet },
						{ id: "description", header: "Description", sortingField: "description", cell: (item) => item.description },
						{ id: "date", header: "Date", sortingField: "date", cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
						{ id: "action", header: "Action", cell: (item) => <><Button
								className={[this.props.styles["btnUID"], this.props.styles["red"]].join(" ")}
								variant="normal"
								onClick={() => {
									setTimeout(() => {
										this.deleteBlackListWithdrawal(item.id);
									}, 0);
								}}
								children={"Delete"}
							/></> },
					]}
					items={this.props.blackListWithdrawals.data}
					pagination={
						<Pagination
							disabled={!this.props.blackListWithdrawals.loaded}
							currentPageIndex={this.props.blackListWithdrawals.pagination.current}
							pagesCount={this.props.blackListWithdrawals.pagination.total}
							onChange={(page) => {
								this.props.setBlackListWithdrawals({ ...this.props.blackListWithdrawals, pagination: { ...this.props.blackListWithdrawals.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => this.props.Interface.loadBlackListWithdrawals(), 250);
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.blackListWithdrawals.preferences.perPage }}
							preferences={{ pageSize: this.props.config.blackListWithdrawals.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("blackListWithdrawals.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, blackListWithdrawals: { ...this.props.config.blackListWithdrawals, perPage: preferences.detail.pageSize } });

								setTimeout(() => this.props.Interface.loadBlackListWithdrawals(), 250);
							}}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Black list withdrawals"
									counter={
										<>
											(
											{
												this.props.blackListWithdrawals.pagination.count
											}
											)
										</>
									}
									actions={
										<SpaceBetween direction="horizontal" size="l">
											<Button
												iconName="add-plus"
												disabled={!this.props.blackListWithdrawals.loaded}
												className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
												onClick={() => {
													setTimeout(() => {
														this.props.setBlackListWithdrawalsAddModal({ ...this.props.blackListWithdrawalsAddModal, show: true });
													}, 0);
												}}
												variant="primary"
												children="Create black list withdrawal"
											/>
										</SpaceBetween>
									}
								/>
							}
						/>
					}
					empty="No black list withdrawals found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const blackListWithdrawals = useRecoilValue(blackListWithdrawalsStore);
		const setBlackListWithdrawals = useSetRecoilState(blackListWithdrawalsStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const blackListWithdrawalsAddModal = useRecoilValue(blackListWithdrawalsAddModalStore);
		const setBlackListWithdrawalsAddModal = useSetRecoilState(blackListWithdrawalsAddModalStore);

		const blackListWithdrawalsEditModal = useRecoilValue(blackListWithdrawalsEditModalStore);
		const setBlackListWithdrawalsEditModal = useSetRecoilState(blackListWithdrawalsEditModalStore);

		return <Component {...props} blackListWithdrawalsEditModal={blackListWithdrawalsEditModal} setBlackListWithdrawalsEditModal={setBlackListWithdrawalsEditModal} blackListWithdrawals={blackListWithdrawals} setBlackListWithdrawals={setBlackListWithdrawals} config={config} setConfig={setConfig} blackListWithdrawalsAddModal={blackListWithdrawalsAddModal} setBlackListWithdrawalsAddModal={setBlackListWithdrawalsAddModal} />;
	};
}

export default withRecoil(BlackListWithdrawals);
